import { AppHeader } from '@ace-clublabs/shared-component-library';

const Header: React.FC = () => {
  return <AppHeader id="ace-header" className="margin24Bottom" displayShadow={false} />;
};

export default Header;
